export const ProductionPlanMealPackaging = (json: IProductionPlanMealPackaging): IProductionPlanMealPackagingModel => {
	const { created_at, updated_at, components, components_qty, ...rest } = json

	return {
		...rest,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		components: components ? components.map(c => DietMealVariantPackagingItem(c)) : [],
		componentsQty: components_qty,
	}
}

export const ProductionPlanMealVariant = (json: IProductionPlanMealVariant): IProductionPlanMealVariantModel => {
	const { packagings, size_id, size_name, variant_id, ...rest } = json

	return {
		...rest,
		packagings: packagings ? packagings.map(p => ProductionPlanMealPackaging(p)) : [],
		sizeId: size_id,
		sizeName: size_name,
		variantId: variant_id,
	}
}

export const ProductionPlanMeals = (json: IProductionPlanMeal): IProductionPlanMealModel => {
	const {
		addon_category,
		allergens,
		meal_category,
		meal_id,
		meal_kind,
		meal_type,
		thumb_url,
		variants,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		addonCategory: addon_category,
		allergens: allergens ? allergens.map(a => DietAllergen(a)) : [],
		mealCategory: meal_category,
		mealId: meal_id,
		mealKind: meal_kind,
		mealType: meal_type,
		thumbUrl: thumb_url,
		variants: variants ? variants.map(variant => ProductionPlanMealVariant(variant)) : [],
	}
}
